// extracted by mini-css-extract-plugin
export default {"option":"ServiceOptions_option__ZfkZw","title":"ServiceOptions_title__K3qHf","discription":"ServiceOptions_discription__xb7um"};